import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d49080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter" }
const _hoisted_2 = { class: "authorized-title" }

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { getCustomerShop } from '@/apis/order'
import { useRtfix } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: ['status'],
  emits: ['update:status'],
  setup(__props, { emit: emits }) {

const props = __props



getCustomerShop().then((res: any) => {
  if (res.success) {
    const customerShopAuthStatus = res.data.customerShopAuthStatus === 1
    emits('update:status', customerShopAuthStatus)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.status)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。')), 1),
          _createVNode(_component_el_button, {
            style: {"margin-left":"6px"},
            type: "primary",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('AuthorizedStore'))))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('去授权')), 1)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})